// extracted by mini-css-extract-plugin
module.exports = {"Icon":"styles_Icon__tm4sM"};